import React from 'react';

const SocialMedia = ({ style }) => {
  const socialList = [
    { num: 1, name: 'icon youtube', url: 'https://google.com', img: '/icons/icon-youtube.svg' },
    { num: 2, name: 'icon instagram', url: 'https://google.com', img: '/icons/icon-instagram.svg' },
    { num: 3, name: 'icon x-twitter', url: 'https://google.com', img: '/icons/icon-x.svg' },
    { num: 4, name: 'icon facebook', url: 'https://google.com', img: '/icons/icon-facebook.svg' },
    { num: 5, name: 'icon threads', url: 'https://google.com', img: '/icons/icon-threads.svg' },
    { num: 6, name: 'icon telegram', url: 'https://google.com', img: '/icons/icon-telegram.svg' },
  ];

  return (
    <div className="el-social-media">
      {socialList.map(media => (
        <div key={media.num} className={media.name}>
          <a href={media.url}>
            <img alt={media.name} src={media.img} style={style} />
          </a>
        </div>
      ))}
    </div>
  );
};

export default SocialMedia;
